import CommunicationPhaseCard from './TrackerPhaseCard.vue';

export default CommunicationPhaseCard;
